import { useState } from 'react';

// Fixed to the bottom of every step: the running total (with the full
// breakdown one tap away), and back/next. "Next" submits the step's form
// through the form attribute, so the browser's own required-field checks
// still run even though the button lives outside the form.
function OrderBar({
  total,
  totalLabel,
  facts,
  breakdown,
  breakdownLabel,
  backLabel,
  onBack,
  nextLabel,
  nextDisabled,
  busy,
  hint,
  error,
  formId,
}) {
  const [open, setOpen] = useState(false);

  return (
    <div className="of-bar">
      {open && breakdown && (
        <div className="of-breakdown" id="of-breakdown">
          {breakdown}
        </div>
      )}

      <div className="of-bar-inner">
        <div className="of-total">
          <span className="of-total-label">{totalLabel}</span>
          <strong>{total}</strong>
          <span className="of-total-facts">
            {facts}
            {breakdown && (
              <>
                {' '}
                &middot;{' '}
                <button
                  type="button"
                  className="of-link"
                  onClick={() => setOpen((v) => !v)}
                  aria-expanded={open}
                  aria-controls="of-breakdown"
                >
                  {breakdownLabel}
                </button>
              </>
            )}
          </span>
        </div>

        <div className="of-bar-actions">
          {(error || hint) && (
            <p className={error ? 'of-bar-error' : 'of-bar-hint'} role={error ? 'alert' : undefined}>
              {error || hint}
            </p>
          )}
          {onBack && (
            <button type="button" className="of-back" onClick={onBack}>
              <span aria-hidden="true">&larr;</span> <span className="of-back-text">{backLabel}</span>
            </button>
          )}
          <button type="submit" form={formId} className="of-btn" disabled={nextDisabled || busy}>
            {nextLabel} <span aria-hidden="true">&rarr;</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default OrderBar;
